<template lang="pug">
  .gw-headline__menu
    .gw-headline__item(
      v-for="(link, index) in links",
      :key="index"
    )
      a.gw-headline__item-link(:href="link.href" target="_blank") {{ link.name }}
</template>

<script>
export default {
  name: "MyGamesHeadlineNavigation",

  props: {
    links: Array,
  },
};
</script>
